import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import Button from '../../Button'

import useStyles from './styles'

function FileUploadInput({
  onFileUpload,
  multiple = false,
  maxSize,
  uploadButtonClassName,
  uploadBtnLabelClassName,
  ...props
}) {
  const { t } = useTranslation()
  const classes = useStyles()

  const inputFileRef = useRef()

  const inputClickHandler = () => {
    inputFileRef.current.click()
  }

  const selectFile = e => {
    const { files } = e.target
    if (files && files[0]) {
      onFileUpload(multiple ? files : files[0])
    }

    // this line right below will reset the
    // input field so if you removed it you can re-add the same file
    e.target.value = ''
  }

  return (
    <div className={classes.buttonWrap}>
      <label htmlFor="upload" className={classnames(classes.uploadFileBtnLabel, uploadBtnLabelClassName)}>
        <Button
          className={classnames('dark', classes.uploadFileBtn, uploadButtonClassName)}
          type={'button'}
          onClick={inputClickHandler}
        >
          {t('Select File')}
        </Button>
      </label>
      <input
        id="upload"
        ref={inputFileRef}
        className={classes.inputBtn}
        type="file"
        multiple={multiple}
        onChange={selectFile}
        {...props}
      />
    </div>
  )
}

FileUploadInput.propTypes = {
  onFileUpload: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  maxSize: PropTypes.number,
  uploadButtonClassName: PropTypes.string,
  uploadBtnLabelClassName: PropTypes.string
}

export default FileUploadInput
